import { 
  ACHIEVEMENT_CATEGORY_LIST_FAIL, 
  ACHIEVEMENT_CATEGORY_LIST_REQUEST, 
  ACHIEVEMENT_CATEGORY_LIST_SUCCESS, 
  ACHIEVEMENT_EVENT_LIST_FAIL, 
  ACHIEVEMENT_EVENT_LIST_REQUEST, 
  ACHIEVEMENT_EVENT_LIST_ALL_SUCCESS,
  ACHIEVEMENT_EVENT_LIST_SUCCESS,
 } from '../constants/achievementConstants'

export const AchievementEventListReducer = (state = {listsOffice:[]}, action) => {
  switch (action.type) {
    case ACHIEVEMENT_EVENT_LIST_REQUEST:
      return{ ...state, loading: true, error: [] }
    case ACHIEVEMENT_EVENT_LIST_SUCCESS:
      return{ ...state, loading: false, achievementEvent: action.payload.data, achievementEventList: action.payload.data.data }
    case ACHIEVEMENT_EVENT_LIST_ALL_SUCCESS:
      return{ ...state, loading: false, achievementEventList: action.payload.data }
    case ACHIEVEMENT_EVENT_LIST_FAIL:
      return{ ...state, loading: false, error: action.payload }
    default:
      return state
  }
}

export const AchievementCategoryListReducer = (state = {listsOffice:[]}, action) => {
  switch (action.type) {
    case ACHIEVEMENT_CATEGORY_LIST_REQUEST:
      return{ ...state, loading: true, error: [] }
    case ACHIEVEMENT_CATEGORY_LIST_SUCCESS:
      return{ ...state, loading: false, achievementCategory: action.payload.data, achievementCategoryList: action.payload.data.data }
    case ACHIEVEMENT_CATEGORY_LIST_FAIL:
      return{ ...state, loading: false, error: action.payload }
    default:
      return state
  }
}